<span [id]="status().id">{{status().name()}}</span>
